import Entities from '../components/pages/Entities/Entities.vue'
import Sports from '../components/pages/Entities/Sports/Sports'
import Events from '../components/pages/Entities/Events/Events'
import Teams from '../components/pages/Entities/Teams/Teams'

const EventsTableHead = () => import('../components/pages/Entities/TableHeads/EventsTableHead')
const SportsTableHead = () => import('../components/pages/Entities/TableHeads/SportsTableHead')
const TeamsTableHead = () => import('../components/pages/Entities/TableHeads/TeamsTableHead')
const EntitiesFilters = () => import('../components/pages/Entities/EntitiesFilters')

export default [
  {
    path: '/entities',
    name: 'entities',
    component: Entities,
    children: [
      {
        path: 'sports',
        name: 'entities.sports.name',
        components: {
          default: Sports,
          tableHead: SportsTableHead
        }
      },
      {
        path: 'events',
        name: 'entities.events.name',
        components: {
          default: Events,
          tableHead: EventsTableHead,
          filters: EntitiesFilters
        }
      },
      {
        path: 'teams',
        name: 'entities.teams.name',
        components: {
          default: Teams,
          tableHead: TeamsTableHead,
          filters: EntitiesFilters
        }
      }
    ]
  }
]
